import React, { useEffect, useState } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import { CardProgramComp } from '../..';
import { useSelector, useDispatch } from 'react-redux'
import errorHandler from '../../../helpers/errorHandler'
import axios from '../../../lib/axios'

const TabsCategories = (props) => {

    const [catalogPrograms, setCatalogPrograms] = useState([])
    const [programCategory, setprogramCategory] = useState(1)

    const dispatch = useDispatch()
    const dataInputRegistration = useSelector(state => state.dataInputRegistration)
    const handleChangeFormInput = (e) => {
        dispatch({ type: 'SET_SEARCH_PROGRAM', 'value': e.target.value });
    }

    const handleCLoseModal = () => {
        props.close(false)
    }

    const fetchCatalogPrograms = async () => {
        try {
            const options = {
                url: '/users/programs',
                method: 'GET'
            }
            const { data } = await axios(options)
            // console.log(data)
            setCatalogPrograms(data.data)

        } catch (err) {
            if (err) {
                console.log(err?.response?.data)
                errorHandler({ err: err?.response?.data || err })
            }
        }
    }

    useEffect(() => {
        fetchCatalogPrograms()
    }, [])

    const handleClickTab = (e) => {
        // console.log(e)
        setprogramCategory(e)
    }
    // console.log(catalogPrograms)

    return (
        <>
            <div className='row'>
                {/*begin::Search*/}
                <div className="d-flex align-items-center position-relative me-4 mb-3">
                    <input type="text" className="form-control form-control form-control ps-9" placeholder="Cari Program..." onChange={(e) => handleChangeFormInput(e)} value={dataInputRegistration.searchProgram} />
                </div>
                {/*end::Search*/}
                <Tabs defaultActiveKey="1" className="mb-3" style={{ paddingLeft: '1%', paddingRight: '1%' }} onSelect={(e => handleClickTab(e))}>
                    {
                        catalogPrograms.map(row => (
                            <Tab key={row.id} eventKey={row.id} title={row.label}>
                                <CardProgramComp
                                    key={row.id}
                                    programs={row.Programs}
                                    programCategory={programCategory}
                                    bundlingPrograms={row.BundlingPrograms}
                                    close={handleCLoseModal}
                                />
                            </Tab>
                        ))
                    }
                </Tabs>
            </div >
        </>
    )
}

export default TabsCategories
